import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MB_DIALOG_DATA, MbDialogData, MbDialogRef, MbDialogFooter, MbDialogBody, MbIconModule, MbButton } from '@am/moebius';
import { SharedModule } from '@shared/shared.module';

export enum RatePriceChangedComponentCloseEvents {
  CONFIRM_RESERVATION,
  CLOSE_DIALOG,
  REFRESH_PRICE,
}

@Component({
  selector: 'app-rate-price-changed',
  standalone: true,
  imports: [CommonModule, MbDialogFooter, MbDialogBody, MbIconModule, MbButton, SharedModule],
  templateUrl: './rate-price-changed.component.html',
  styleUrls: ['./rate-price-changed.component.scss'],
})
export class RatePriceChangedComponent implements OnInit {
  public closeEvents = RatePriceChangedComponentCloseEvents;

  constructor(
    @Inject(MB_DIALOG_DATA) public dialogData: MbDialogData,
    public dialogRef: MbDialogRef<RatePriceChangedComponent>,
  ) {}

  ngOnInit(): void {}

  closeDialog(closeEvent: RatePriceChangedComponentCloseEvents) {
    this.dialogRef.close({ closeEvent });
  }
}
